/** Stripe Connect account for dashboard deep links (matches STRIPE_SECRET_KEY account). */
const STRIPE_DASHBOARD_ACCOUNT =
  import.meta.env.VITE_STRIPE_DASHBOARD_ACCOUNT ?? "acct_1PxHQuRuuOYqe24V";

/** `test` → /test/... ; `live` → /... (no test segment). */
const STRIPE_DASHBOARD_MODE =
  import.meta.env.VITE_STRIPE_DASHBOARD_MODE ?? "test";

function stripeDashboardBasePath(): string {
  const acct = STRIPE_DASHBOARD_ACCOUNT.trim();
  if (STRIPE_DASHBOARD_MODE === "live") {
    return `https://dashboard.stripe.com/${acct}`;
  }
  return `https://dashboard.stripe.com/${acct}/test`;
}

export function stripeDashboardProductUrl(
  productId: string | null | undefined
): string {
  const id = typeof productId === "string" ? productId.trim() : "";
  if (!id) return "";
  return `${stripeDashboardBasePath()}/products/${id}`;
}

export function stripeDashboardPaymentUrl(
  paymentIntentId: string | null | undefined
): string {
  const id = typeof paymentIntentId === "string" ? paymentIntentId.trim() : "";
  if (!id) return "";
  return `${stripeDashboardBasePath()}/payments/${id}`;
}

export function resolveShowStripeProductId(show: {
  stripe_product_id?: string | null;
  shows?: Array<{ stripe_product_id?: string | null }> | null;
} | null | undefined): string | null {
  if (!show) return null;
  const direct =
    typeof show.stripe_product_id === "string" ? show.stripe_product_id.trim() : "";
  if (direct) return direct;
  const children = show.shows;
  if (!Array.isArray(children)) return null;
  for (const child of children) {
    const id =
      typeof child?.stripe_product_id === "string" ? child.stripe_product_id.trim() : "";
    if (id) return id;
  }
  return null;
}
